export default __webpack_public_path__ + "static/healthplans-32e3c3c977f2a5ddedc94370f065ef59.jpg";